<template>
<div style="width:100%">
  <div v-for="(item, index) in items_escalamientos" :key="index">
    <sfcItem v-if="item.subestado_id === 6" :item="item" :session="session" @view_sfc="ver_sfc" @reasignar_sfc="abrir_reasignar"></sfcItem>
    <crmItem v-else :item="item" @view_crm="ver_crm"></crmItem>
  </div>
  <lecturaDialog :dialogLectura="dialogLectura" :session="session" :items="items" :rules="rules" :colores="colores" :token="token" :registro_id="registro_id" @closed_ventana="cerrar_ventana"></lecturaDialog>
  <sfcDialog :dialogSfc="dialogSfc" :session="session" :items="items" :rules="rules" :colores="colores" :token="tokenSfc" :registro_id="registro_id" @closed_ventana_sfc="cerrar_ventana_sfc"></sfcDialog>
  <reasignarDialog :dialogReasignar="dialogReasignar" :rules="rules" :colores="colores" :token="tokenReasignar" :registro="registroReasignar" @closed_reasignar="cerrar_reasignar" @reasignado="confirmar_reasignar"></reasignarDialog>
  </div>
</template>

<script>
import crmItem from '@/components/bandejas/bandeja_pqrs_crmComponent.vue'
import sfcItem from '@/components/bandejas/bandeja_pqrs_sfcComponent.vue'

import lecturaDialog from '@/components/inbound/lectura_dialogoComponent.vue'
import sfcDialog from '@/components/sfc/form_dialogoComponent.vue'
import reasignarDialog from '@/components/bandejas/bandeja_reasignarComponent.vue'
import recFunciones from '@/js/rec_funciones.js'
export default {
  name: 'bandeja_pqr_listadoComponent',
  components: {
    crmItem,
    sfcItem,
    sfcDialog,
    lecturaDialog,
    reasignarDialog
  },
  props: ['session', 'items_escalamientos', 'colores', 'rules', 'items'],
  mixins: [recFunciones],
  data: () => ({
    dialogSfc: false,
    tokenSfc: 0,
    dialogLectura: false,
    dialogReasignar: false,
    tokenReasignar: 0,
    registroReasignar: null,
    token: 0,
    registro_id: 0
  }),
  methods: {
    colorVencimiento (item) {
      // console.log(item.dias)
      let color = 'black'
      if (item.dias < -5) {
        color = 'green'
      } else if (item.dias >= -5 && item.dias <= -1) {
        color = 'amber'
      } else {
        color = 'red'
      }
      return color
    },
    abrirColores () {
      alert('1')
    },
    ver_crm (pItem) {
      this.dialogLectura = true
      this.token = this.token + 1
      this.registro_id = pItem.id
    },
    ver_sfc (pItem) {
      this.dialogSfc = true
      this.tokenSfc = this.tokenSfc + 1
      this.registro_id = pItem.id
    },
    cerrar_ventana () {
      this.dialogLectura = false
    },
    cerrar_ventana_sfc () {
      this.dialogSfc = false
    },
    abrir_reasignar (pItem) {
      this.registroReasignar = pItem
      this.dialogReasignar = true
      this.tokenReasignar = this.tokenReasignar + 1
    },
    cerrar_reasignar () {
      this.dialogReasignar = false
    },
    confirmar_reasignar () {
      this.dialogReasignar = false
      // El caso cambio de dueño: hay que recargar la bandeja para que desaparezca de esta.
      this.$emit('refresh_pqrs')
    }
  }
}
</script>
